import React from "react";

const Footer = () => {
  return (
    <footer>
      <p>Anjula Timsina &copy; 2021</p>
    </footer>
  );
};

export default Footer;
